export default __webpack_public_path__ + "static/media/box3.7a5f0c6f.svg";